export const API_URL = process.env.REACT_APP_API_URL || 'https://slavikmanagement.staging.fm-dev-1.futuramicmedia.com/api';
export const APP_URL = process.env.REACT_APP_URL || 'https://slavikmanagement.staging.fm-dev-1.futuramicmedia.com';
export const SECRET_KEY = process.env.REACT_SECRET_KEY || 'futuramic';
export const ONE_SIGNAL_APP_ID = process.env.REACT_APP_ONE_SIGNAL_APP_ID || '';
export const ENV = process.env.NODE_ENV  || 'production';
export const APP_VERSION = process.env.REACT_APP_VERSION || '3.0.0';
